import { useAuth } from '../../hooks/useAuth';
import { Link } from 'react-router-dom';

const Header = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <header className="header">
      <div className="logo">
         <h5 className="text-4xl font-black text-slate-900 tracking-tight">
            Hello, {user?.role === 'member' ? user.name : 'Admin '}
          </h5>
       
      </div>
      <div className="user-info">
        <span>
          </span>
        <button onClick={handleLogout}>Logout</button>
      </div>
    </header>
  );
};

export default Header;